var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa-cog",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,28.7v4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2L35.1,34c-0.2,0.7-0.5,1.2-0.7,1.7 c0.4,0.6,1.1,1.4,1.9,2.5c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.3-0.2,0.4c-0.3,0.5-0.9,1.1-1.8,2c-0.9,0.9-1.4,1.3-1.7,1.3 c-0.1,0-0.3-0.1-0.5-0.2l-2.5-2c-0.5,0.3-1.1,0.5-1.7,0.7c-0.2,1.7-0.4,2.8-0.5,3.4c-0.1,0.3-0.3,0.5-0.7,0.5h-4 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4l-0.5-3.4c-0.6-0.2-1.1-0.4-1.6-0.7l-2.6,2c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.3-0.1-0.5-0.2c-1.5-1.4-2.5-2.4-3-3.1c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4c0.2-0.3,0.5-0.7,0.9-1.2 s0.8-1,1-1.3c-0.3-0.6-0.6-1.2-0.7-1.8l-3.3-0.5c-0.2,0-0.3-0.1-0.4-0.2C11,33,11,32.9,11,32.7v-4c0-0.1,0-0.3,0.1-0.4 c0.1-0.1,0.2-0.2,0.3-0.2l3.4-0.5c0.2-0.6,0.4-1.1,0.7-1.7c-0.5-0.7-1.1-1.5-1.9-2.5c-0.1-0.1-0.2-0.3-0.2-0.4 c0-0.1,0.1-0.3,0.2-0.4c0.3-0.4,0.9-1.1,1.8-2c0.9-0.9,1.5-1.3,1.7-1.3c0.2,0,0.3,0.1,0.5,0.2l2.5,1.9c0.5-0.3,1.1-0.5,1.7-0.7 c0.2-1.7,0.4-2.8,0.5-3.4c0.1-0.3,0.3-0.5,0.7-0.5h4c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4l0.5,3.4 c0.6,0.2,1.1,0.4,1.6,0.7l2.6-2c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2c1.6,1.4,2.6,2.5,3,3.1c0.1,0.1,0.1,0.2,0.1,0.4 c0,0.1-0.1,0.3-0.1,0.4c-0.2,0.3-0.5,0.7-0.9,1.2c-0.4,0.6-0.8,1-1,1.3c0.3,0.6,0.6,1.2,0.7,1.8l3.3,0.5c0.2,0,0.3,0.1,0.4,0.2 C38.9,28.4,39,28.6,39,28.7z M28.3,34c0.9-0.9,1.4-2,1.4-3.3c0-1.3-0.5-2.4-1.4-3.3c-0.9-0.9-2-1.4-3.3-1.4 c-1.3,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2-1.4,3.3c0,1.3,0.5,2.4,1.4,3.3c0.9,0.9,2,1.4,3.3,1.4C26.3,35.4,27.4,34.9,28.3,34z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 30.7,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDefault);
export default __webpack_public_path__ + "static/media/settings-default.d04dd41e776c8ed30073f50fc5d9ce82.svg";
export { ForwardRef as ReactComponent };